<template>
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
  >
    <path d="M3 1.5C3 0.671573 3.67157 0 4.5 0H11.5C12.3284 0 13 0.671573 13 1.5V2H13.5C14.8807 2 16 3.11929 16 4.5V9.5C16 10.3284 15.3284 11 14.5 11H13V12.5C13 13.3284 12.3284 14 11.5 14H4.5C3.67157 14 3 13.3284 3 12.5V11H1.5C0.671573 11 0 10.3284 0 9.5V4.5C0 3.11929 1.11929 2 2.5 2H3V1.5ZM4 2H12V1.5C12 1.22386 11.7761 1 11.5 1H4.5C4.22386 1 4 1.22386 4 1.5V2ZM3 10V8.5C3 7.67157 3.67157 7 4.5 7H11.5C12.3284 7 13 7.67157 13 8.5V10H14.5C14.7761 10 15 9.77614 15 9.5V4.5C15 3.67157 14.3284 3 13.5 3H2.5C1.67157 3 1 3.67157 1 4.5V9.5C1 9.77614 1.22386 10 1.5 10H3ZM4.5 8C4.22386 8 4 8.22386 4 8.5V12.5C4 12.7761 4.22386 13 4.5 13H11.5C11.7761 13 12 12.7761 12 12.5V8.5C12 8.22386 11.7761 8 11.5 8H4.5Z" />
  </svg>
</template>
